import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import * as fromProfile from './../store/profile.reducers';
import * as fromUser from './../../user/store/user.reducers';
import * as fromApp from './../../store/app.reducers';

import * as ProfileActions from './../store/profile.actions';

@Component({
    selector: 'app-profile-list',
    templateUrl: './profile-list.component.html',
    styleUrls: ['./profile-list.component.scss'],
    standalone: false
})
export class ProfileListComponent implements OnInit {

  profileState: Observable<fromProfile.State>;
  userState: Observable<fromUser.State>;
  limitPerPage = 40;
  limit = 40;
  page = 1;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
    this.userState = this.store.select('user');
    this.loadData(this.limitPerPage, 1);
  }

  loadData(limit, page) {
    this.store.dispatch(
      new ProfileActions.GetAudits({params: {
        limit: limit,
        page: page
      }})
    );
    this.limit = limit;
    this.page = page;
  }

  checkCertificateAvailability(profileAddedUnixtime: number) {
    const actualTime = parseInt((new Date().getTime() / 1000).toString());
    if (profileAddedUnixtime > (actualTime - 3600 * 24 * 32)) {
      return true;
    }

    return false;
  }

  changeProfileStatus(profileId: number, status: number) {
    this.store.dispatch(
      new ProfileActions.UpdateProfileStatus({
        profileId: profileId,
        status: status
      })
    );
  }

}
